import React from 'react'

import { Box, Row } from 'components/_new/layout'
import { LazyImage } from 'components/_new/ui'
import Text from 'components/_new/typography/Text/Text'
import Rating from 'components/_new/product/Rating/Rating'
import NotesSection from 'components/_new/productCard/components/NotesSection/NotesSection'

import UpchargePriceInfo from './UpchargePriceInfo/UpchargePriceInfo'

import s from './Product.scss'


type ProductProps = {
  data: {
    image: string
    brand: string
    name: string
    rating: number
    description: string
    upchargePrice: number
    notes: Array<{
      id: number
      name: string
      slug: string
      image: string
    }>
  }
}

const Product: React.FunctionComponent<ProductProps> = (props) => {
  const {
    data: {
      image, brand, name, rating, notes,
      upchargePrice, description,
    },
  } = props

  return (
    <Box className={s.inner} alignLeft>
      <Box mb={16}>
        <LazyImage className={s.image} src={image} h={300} x2 x3 withIntersector />
      </Box>
      <Row align="center">
        <Rating value={rating} />
        {
          Boolean(upchargePrice) && (
            <UpchargePriceInfo upchargePrice={upchargePrice} />
          )
        }
      </Row>
      <Box mt={8}>
        <Text message={brand} size="16-20" semibold />
        <Text message={name} size="14-24" />
      </Box>
      {
        Boolean(notes && notes.length) && (
          <Box mt={24}>
            <NotesSection
              notes={notes}
              noteClassName={s.note}
            />
          </Box>
        )
      }
      {
        Boolean(description) && (
          <Box mt={24}>
            <Text message={description} size="14-24" color="black" html />
          </Box>
        )
      }
    </Box>
  )
}


export default Product
